module.exports = __webpack_public_path__ + "assets/media/vk-color.b96c9152.svg";